import styled from 'styled-components';
import { colors, spacing, typography, radius, shadows } from '../../design-system/tokens';

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const TriggerButton = styled.button`
  background: transparent;
  border: none;
  padding: ${spacing[1]};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${radius.md};
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.background.secondary};
  }

  .anticon {
    font-size: ${typography.fontSizes.base};
    color: ${colors.text.primary};
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
`;

export const DropdownContent = styled.div<{ 
  $position?: 'left' | 'right'; 
  $width?: number; 
  $placement?: 'top' | 'bottom';
  $fixedPosition?: { top?: number; bottom?: number; left?: number; right?: number };
}>`
  ${props => props.$placement === 'top' && props.$fixedPosition ? `
    position: fixed;
    ${props.$fixedPosition.top !== undefined ? `top: ${props.$fixedPosition.top}px;` : ''}
    ${props.$fixedPosition.bottom !== undefined ? `bottom: ${props.$fixedPosition.bottom}px;` : ''}
    ${props.$fixedPosition.left !== undefined ? `left: ${props.$fixedPosition.left}px;` : ''}
    ${props.$fixedPosition.right !== undefined ? `right: ${props.$fixedPosition.right}px;` : ''}
  ` : `
    position: absolute;
    ${props.$position === 'left' ? 'left: 0;' : 'right: 0;'}
    ${props.$placement === 'top' ? 'bottom: 100%; margin-bottom: ' + spacing[1] + ';' : 'top: 100%; margin-top: ' + spacing[1] + ';'}
  `}
  background: white;
  border-radius: ${radius.lg};
  box-shadow: ${shadows.lg};
  width: ${props => props.$width}px;
  z-index: 1000;
  padding: ${spacing[1]};
  border: 1px solid ${colors.border.primary};
`;

export const DropdownItem = styled.button<{ disabled?: boolean; $variant?: 'default' | 'danger' | 'success' | 'primary' }>`
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding: ${spacing[2]} ${spacing[4]};
  background: none;
  border: none;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.5 : 1};
  border-radius: ${radius.md};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${colors.background.secondary};
  }

  ${props => props.$variant === 'danger' && `
    &:hover:not(:disabled) {
      background: ${colors.feedback.warning.surface};
      .anticon {
        color: ${colors.feedback.warning.primary};
      }
    }
  `}
  
  ${props => props.$variant === 'success' && `
    &:hover:not(:disabled) {
      background: ${colors.feedback.success.surface};
      .anticon {
        color: ${colors.feedback.success.primary};
      }
    }
  `}

  ${props => props.$variant === 'primary' && `
    &:hover:not(:disabled) {
      background: ${colors.brand.primarySurface};
      .anticon {
        color: ${colors.brand.primary};
      }
    }
  `}
`;

export const IconWrapper = styled.div<{ $variant?: 'default' | 'danger' | 'success' | 'primary' }>`
  margin-right: ${spacing[2]};
  color: ${props => {
    switch (props.$variant) {
      case 'danger':
        return colors.feedback.warning.primary;
      case 'success':
        return colors.feedback.success.primary;
      case 'primary':
        return colors.brand.primary;
      default:
        return colors.text.tertiary;
    }
  }};
  display: flex;
  align-items: center;
`;

export const ItemContent = styled.div`
  text-align: left;
  flex: 1;
`;

export const ItemLabel = styled.div`
  color: ${colors.text.primary};
  font-size: ${typography.fontSizes.sm};
  font-weight: ${typography.fontWeights.medium};
`;

export const ItemDescription = styled.div`
  color: ${colors.text.tertiary};
  font-size: ${typography.fontSizes.xs};
  margin-top: ${spacing[1]};
`;

export const SectionTitle = styled.div`
  padding: ${spacing[1]} ${spacing[4]};
  color: ${colors.text.tertiary};
  font-size: ${typography.fontSizes.xs};
  font-weight: ${typography.fontWeights.medium};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const Divider = styled.div`
  height: 1px;
  background: ${colors.background.tertiary};
  margin: ${spacing[1]} 0;
`; 